import { useRequest } from 'features/request/useRequest';
import { SortEnumType } from 'gql/graphql';

import { debounce } from 'debounce';
import { useCallback, useMemo, useState } from 'react';

import { getWhereVariables } from '../helpers';
import { uerContractActionLogEntries } from '../StoringHistoryChangeQueries';

export const useStoringHistoryData = (contractId: number, dateValue: [Date?, Date?] | null, isOpenModal: boolean) => {
    const [searchString, setSearchString] = useState('');
    const [querySearch, setQueryWhere] = useState(undefined);

    const handleSearch = useCallback(({ value }) => {
        setQueryWhere((prevFilters: any) => ({
            ...prevFilters,
            searchString: value,
        }));
    }, []);

    const debouncedSearch = useMemo(() => debounce(handleSearch, 500), [handleSearch]);

    const handleChangeSearchString = useCallback(
        ({ value }) => {
            setSearchString(value);
            debouncedSearch({ value });
        },
        [debouncedSearch],
    );

    const variables = useMemo(
        () => ({
            contractId,
            where: getWhereVariables(querySearch, dateValue),
            order: [{ date: SortEnumType.Desc, id: SortEnumType.Desc }],
        }),
        [contractId, dateValue, querySearch],
    );

    const requestId = `{contractLogEntries_${contractId}}`;

    const [contractLogEntriesData, contractLogEntriesStatus, ,] = useRequest({
        requestId,
        query: uerContractActionLogEntries,
        withEffect: Boolean(contractId) && isOpenModal,
        variables,
    });

    const dataItems = useMemo(
        () => contractLogEntriesData?.uerContractActionLogEntries?.items,
        [contractLogEntriesData?.uerContractActionLogEntries?.items],
    );

    const clearSearchValue = useCallback(() => {
        setQueryWhere(undefined);
        setSearchString('');
    }, []);

    return {
        dataItems,
        contractLogEntriesStatus,
        handleChangeSearchString,
        searchString,
        clearSearchValue,
    };
};
